// extracted by mini-css-extract-plugin
export var actions = "_8g-8";
export var arrow = "_8g-5";
export var card = "_8g-0";
export var cardWrapper = "_8g-9";
export var fieldName = "_8g-3";
export var newValue = "_8g-6";
export var oldValue = "_8g-4";
export var orangeGlowFade = "_8g-c";
export var productSection = "_8g-1";
export var scrollToBottom = "_8g-b";
export var scrollToBottomAnchor = "_8g-a";
export var scrollToBottomIcon = "_8g-d";
export var showAllButton = "_8g-7";
export var table = "_8g-2";